import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/upcoming')({
  beforeLoad: () => {
    throw redirect({ to: '/tasks/upcoming' });
  },
});
